import { render } from "./AppStepNavigation.vue?vue&type=template&id=6275f938&scoped=true"
import script from "./AppStepNavigation.vue?vue&type=script&lang=js"
export * from "./AppStepNavigation.vue?vue&type=script&lang=js"

import "./AppStepNavigation.vue?vue&type=style&index=0&id=6275f938&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Tomi\\PhpstormProjects\\frontend-v2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6275f938"]])

export default __exports__